import { ThemeConfig, theme } from 'antd';
import { palette } from '@doer/frontend-components/theme';
import { typography } from './typography';
import { tokens } from './tokens';

const accent = palette.primitives.purple.purple550;
const defaultColor = palette.primitives.purple.purple200;

export const customTheme: ThemeConfig = {
  token: {
    fontFamily: typography.fontFamilies.inter,
    fontFamilyCode: typography.fontFamilies.inter,
    fontSize: 14,
    colorBgBase: tokens.colors.primary.white,
    colorTextBase: '#3A3A3B',
    colorPrimary: '#d9d9d9',
    colorSuccess: tokens.colors.supporting.green[600],
    colorWarning: tokens.colors.supporting.yellow[600],
    colorError: tokens.colors.supporting.red[600],

    // Map Tokens
    colorBgLayout: tokens.colors.primary.white,
    fontSizeHeading1: 16,
    fontSizeHeading2: 16,
    fontSizeHeading3: 16,
    fontSizeHeading4: 16,
    lineHeightHeading1: typography.heading.xl.lineHeight,
    lineHeightHeading2: typography.heading.lg.lineHeight,
    lineHeightHeading3: typography.heading.md.lineHeight,
    lineHeightHeading4: typography.heading.sm.lineHeight,
    fontSizeXL: 14,
    fontSizeLG: 14,
    fontSizeSM: 14,
    lineHeightLG: typography.body.lg.lineHeight,
    lineHeightSM: typography.body.sm.lineHeight

    // Alias Tokens
  },

  algorithm: theme.compactAlgorithm,

  components: {
    Typography: {
      fontFamilyCode: typography.fontFamilies.inter
    },
    Button: {
      algorithm: true,
      borderRadius: 10,
      contentFontSize: 14,

      colorPrimary: defaultColor,
      colorPrimaryHover: 'rgba(102, 126, 234, 0.15)',
      colorPrimaryBg: 'rgba(102, 126, 234, 0.1)',
      colorPrimaryBorder: 'rgba(102, 126, 234, 0.3)',

      defaultBg: 'rgba(102, 126, 234, 0.1)',
      defaultColor: defaultColor,
      defaultBorderColor: 'rgba(102, 126, 234, 0.3)',

      colorBgContainerDisabled: '#f5f5f5',
      colorTextDisabled: '#999',
      borderColorDisabled: '#e0e0e0',

      boxShadow: '0 0 12px rgba(102, 126, 234, 0.15)'
    },

    // Checkbox y Radio derivan el color del estado TILDADO del colorPrimary GLOBAL,
    // que acá es gris (#d9d9d9) — un check marcado se veía gris, como deshabilitado
    // (modal de invalidar en social-admin, "Enviar a Social" en la library de reels).
    // Override puntual al accent; NO tocamos el colorPrimary global porque medio antd
    // deriva de él (focus borders, links, Select activo, etc.).
    Checkbox: {
      colorPrimary: accent,
      colorPrimaryHover: palette.primitives.purple.purple600
    },

    Radio: {
      colorPrimary: accent,
      colorPrimaryHover: palette.primitives.purple.purple600
    },

    Tree: {
      nodeHoverBg: palette.primitives.grey.grey50,
      nodeSelectedBg: `${accent}1A`,
      nodeSelectedColor: accent,
      directoryNodeSelectedBg: `${accent}1A`,
      directoryNodeSelectedColor: accent
    },

    Menu: {
      itemColor: palette.primitives.grey.grey500,
      itemHoverColor: palette.primitives.grey.grey800,
      itemHoverBg: palette.primitives.grey.grey0,
      itemSelectedColor: accent,
      itemSelectedBg: `${accent}1A`,
      horizontalItemHoverColor: palette.primitives.grey.grey800,
      horizontalItemHoverBg: palette.primitives.grey.grey0,
      horizontalItemSelectedColor: accent,
      horizontalItemSelectedBg: `${accent}1A`
    },

    Tabs: {
      itemActiveColor: '#953DFF',
      itemHoverColor: '#953DFF',
      itemSelectedColor: '#953DFF',
      inkBarColor: '#953DFF',
      cardBg: 'white'
    }
  }
};
